<template>
  <SectionTemplate :title="title" :subtitle="subtitle" :loading="loading">
    <v-row class="mt-3 mt-sm-5 mt-md-7 mt-lg-9">
      <v-col cols="6" md="3" v-for="(item, keyItems) in items" :key="keyItems">
        <ProductCard :item="item" />
      </v-col>
    </v-row>

    <div class="mt-8 mt-md-12">
      <ButtonWidget class="justify-center" :to="path"> VER TODOS </ButtonWidget>
    </div>
  </SectionTemplate>
</template>

<script>
import SectionTemplate from "../templates/SectionTemplate.vue";
import { formatToURL } from "../../utils/formatToURL";
import ProductCard from "../cards/ProductCard.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

const _config = {
  mod: "products",
  path: "/implementos",
};

export default {
  data: () => ({
    loading: true,
    path: _config.path,
    itemsPerPage: 4,
    title: "",
    subtitle: "",
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
  },
  methods: {
    get() {
      this.$rest(_config.mod)
        .get({
          params: {
            itemsPerPage: this.itemsPerPage,
          },
          save: (state, data) => {
            state.list = data.results.map(({ id, img, title, category }) => ({
              img,
              title,
              category: category.title,
              to: `${this.path}/${formatToURL(category.title)}/${formatToURL(
                title
              )}-${id}`,
            }));
            this.title = data.module_informations.title;
            this.subtitle = data.module_informations.subtitle;
          },
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.get();
  },
  watch: {
    $route() {
      this.get();
    },
  },
  components: {
    SectionTemplate,
    ProductCard,
    ButtonWidget,
  },
};
</script>
